<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div class="nav gap-x-3" title="" data-title="网站管理">
      <!-- <el-button
        :icon="Link"
        type="primary"
        link
        Plain
        @click="
          // state.selectId = row.id;
          state.showCode = true
        "
        >官网链接/二维码
      </el-button> -->
      <el-button
        :icon="Link"
        type="primary"
        link
        Plain
        @click="state.showCode = true"
        >报名链接/二维码
      </el-button>
      <!-- <el-button
        :icon="Link"
        type="primary"
        link
        Plain
        @click="
          state.selectId = row.id;
          state.showInfo = true;
        "
        >嘉宾报名链接/二维码
      </el-button>
      <el-button
        :icon="Link"
        type="primary"
        link
        Plain
        @click="
          state.selectId = row.id;
          state.showInfo = true;
        "
        >团队报名链接/二维码
      </el-button> -->
    </div>
    <div
      class="flex-1 rounded-lg bg-white p-2.5 mt-2 overflow-hidden flex flex-col"
    >
      <el-tabs v-model="state.menu" class="c-el-tabs-auto-height">
        <el-tab-pane label="会议信息" name="huiyi">
          <c_huiyi
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'huiyi'"
            @refresh="onRefresh"
          />
        </el-tab-pane>
        <el-tab-pane label="报名表单" name="baoming">
          <c_baoming
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'baoming'"
          />
        </el-tab-pane>
        <el-tab-pane label="新闻管理" name="xinwen">
          <c_xinwen
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'xinwen'"
          />
        </el-tab-pane>
        <el-tab-pane label="日程配置" name="richeng">
          <c_richeng
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'richeng'"
          />
        </el-tab-pane>
        <el-tab-pane label="嘉宾配置" name="jiabin">
          <c_jiabin
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'jiabin'"
          />
        </el-tab-pane>
        <el-tab-pane label="界面配置" name="jiemian">
          <c_jiemian
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'jiemian'"
          />
        </el-tab-pane>
        <el-tab-pane label="关于我们" name="women">
          <c_women
            :meeting_id="props.meeting_id"
            v-if="state.menu == 'women'"
          />
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      v-model="state.showCode"
      title="报名二维码"
      :before-close="
        () => {
          state.showCode = false;
        }
      "
      :show-title="false"
      :width="270"
    >
      <qrcode-vue :value="state.qrocde_link" :size="230"></qrcode-vue>
      <div class="flex mt-6">
        <el-button
          type="info"
          plain
          size="large"
          @click="state.showCode = false"
          >关闭</el-button
        >
        <el-button
          type="primary"
          class="flex-1"
          size="large"
          @click="onCopyLink"
          >复制连接
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

import c_huiyi from "./HuiYi/Index.vue";
import c_baoming from "./BaoMing/Index.vue";
import c_xinwen from "./XinWen/List.vue";
import c_richeng from "./RiCheng/List.vue";
import c_jiabin from "./JiaBin/List.vue";
import c_jiemian from "./JieMian/Index.vue";
import c_women from "./WoMen/Index.vue";

import QrcodeVue from "qrcode.vue";

import { onCopy } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
  },
  components: {
    c_huiyi,
    c_baoming,
    c_xinwen,
    c_richeng,
    c_jiabin,
    c_jiemian,
    c_women,
    QrcodeVue,
  },
  setup(props, { emit }) {
    const state = reactive({
      menu: "huiyi",
    });
    onMounted(() => {
      state.qrocde_link = `http://hwgl.h5.test.ebsys.cn/#/${props.meeting_id}/t1/index`;
    });

    const onRefresh = () => {
      emit("refresh");
    };

    const onCopyLink = () => {
      onCopy(state.qrocde_link);
    };
    return { state, props, onRefresh, onCopyLink };
  },
};
</script>

<style lang="less" scoped></style>
